class ParallaxImage extends HTMLElement {
  constructor() {
    super();
    this.media = null;
    this._currentY = 0;
    this._targetY = 0;
    this.speed = parseFloat(this.getAttribute('speed')) || 1;
  }

  connectedCallback() {
    this.style.overflow = 'hidden';
    this.style.position = 'auto';

    this.media = this.querySelector('img, video');
    if (!this.media) return;

    this.media.style.transform = 'translateY(0)';
    this.media.style.willChange = 'transform';

    ParallaxImage.instances.push(this);
    ParallaxImage.init();
  }

  updateTarget() {
    const rect = this.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const progress =
      (windowHeight - rect.top) / (windowHeight + rect.height);

    const clamped = Math.max(0, Math.min(1, progress));
    this._targetY = (clamped - 0.5) * 200 * this.speed;
  }

  animate() {
    this._currentY += (this._targetY - this._currentY) * 0.08;
    this.media.style.transform = `translateY(${this._currentY}px)`;
  }

  static init() {
    if (this._initialized) return;
    this._initialized = true;

    const update = () => {
      this.instances.forEach(i => i.updateTarget());
      this._ticking = false;
    };

    const loop = () => {
      this.instances.forEach(i => i.animate());
      requestAnimationFrame(loop);
    };

    window.addEventListener('scroll', () => {
      if (!this._ticking) {
        requestAnimationFrame(update);
        this._ticking = true;
      }
    });

    window.addEventListener('resize', update);

    update();
    loop();
  }
}

ParallaxImage.instances = [];
customElements.define('parallax-image', ParallaxImage);
